module.exports = __webpack_public_path__ + "img/hjk2.4354a957.png";